"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DragHandle = void 0;
const react_1 = __importDefault(require("react"));
const react_sortable_hoc_1 = require("react-sortable-hoc");
const DragIndicator_1 = __importDefault(require("@material-ui/icons/DragIndicator"));
/**
 * Draggable handle to change row order.
 */
exports.DragHandle = react_sortable_hoc_1.SortableHandle(({ className }) => (react_1.default.createElement(DragIndicator_1.default, { className: className })));
//# sourceMappingURL=table-field-drag-handle.js.map